module.exports = __webpack_public_path__ + "img/vertical_1_1_7016.4c12ffe4.png";